"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _BaseDropdownSelect = require("./BaseDropdownSelect");
var _excluded = ["variant", "name", "onChange", "options"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1kdyh6es3v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Select/DropdownSingleSelect.tsx";
  var hash = "619b3b130cb1ce52b0f8d61217a0e9493c9e5764";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Select/DropdownSingleSelect.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 67
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 20,
          column: 52
        }
      },
      "2": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 52
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 68
          }
        },
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 26
          },
          end: {
            line: 19,
            column: 27
          }
        },
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 52
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 12,
            column: 12
          },
          end: {
            line: 12,
            column: 19
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 47
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 47
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 18
          }
        }, {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 52
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "619b3b130cb1ce52b0f8d61217a0e9493c9e5764"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kdyh6es3v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1kdyh6es3v();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
cov_1kdyh6es3v().s[0]++;
var DropdownSingleSelect = function DropdownSingleSelect(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? (cov_1kdyh6es3v().b[0][0]++, 'large') : _ref$variant,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? (cov_1kdyh6es3v().b[1][0]++, "od-dropdown-single-select-".concat(variant)) : _ref$name,
    onChange = _ref.onChange,
    options = _ref.options,
    rest = _objectWithoutProperties(_ref, _excluded);
  cov_1kdyh6es3v().f[0]++;
  cov_1kdyh6es3v().s[1]++;
  var onChangeHandler = function onChangeHandler(selectedOption) {
    cov_1kdyh6es3v().f[1]++;
    cov_1kdyh6es3v().s[2]++;
    return (cov_1kdyh6es3v().b[2][0]++, selectedOption) && (cov_1kdyh6es3v().b[2][1]++, onChange(selectedOption.value));
  };
  cov_1kdyh6es3v().s[3]++;
  return /*#__PURE__*/_react["default"].createElement(_BaseDropdownSelect.BaseDropdownSelect, _extends({
    name: name,
    options: options,
    onChange: onChangeHandler,
    variant: variant,
    isSearchable: variant === 'large'
  }, rest));
};
var _default = exports["default"] = DropdownSingleSelect;